import { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { useStores } from '@/utils'
import { IMarketBase } from '@/types'
import { SearchInputSelectFieldGroup } from '@components-v2/molecules/SearchInputSelectFieldGroup'

type Props = {
  placeholder: string
  selectedMarkets: IMarketBase[]
  setFieldValue: (markets: IMarketBase[]) => void
}

type SearchResultItem = {
  instance: IMarketBase
  isSelected: boolean
}

export const MarketSearchSelectField: FC<Props> = observer(({ placeholder, selectedMarkets, setFieldValue }) => {
  const { companies } = useStores()
  const [searchResult, setSearchResult] = useState<IMarketBase[]>([])

  const validSearchResult: SearchResultItem[] = searchResult.map((market) => {
    const isSelected = selectedMarkets.some((m) => m.slug === market.slug)
    return {
      instance: market,
      isSelected,
    }
  })

  // キーワードで検索した結果に選択済みが含まれない場合もあるので、その場合先頭に追加する
  selectedMarkets.forEach((market) => {
    const isSelected = searchResult.some((m) => m.slug === market.slug)
    if (!isSelected) {
      validSearchResult.unshift({
        instance: market,
        isSelected: true,
      })
    }
  })

  const onInputFinished = async (searchWord: string) => {
    if (companies?.markets.length === 0) {
      await companies.fetchMarkets()
    }
    const newMarkets = filterMarketByKeyword(companies.markets, searchWord)
    setSearchResult(newMarkets)
  }

  const filterMarketByKeyword = (markets: IMarketBase[], keyword: string) => {
    return markets.filter((market) => {
      const name = market.name.toLowerCase()
      const slug = market.slug.toLowerCase()
      const word = keyword.toLowerCase()

      return name.includes(word) || slug.includes(word)
    })
  }

  const onSelect = (id: string) => {
    const isSelected = selectedMarkets.some((l) => l.id === id)

    if (isSelected) {
      return
    }

    const target = searchResult.find((l) => l.id === id)
    if (!target) {
      return
    }

    setFieldValue(selectedMarkets.concat(target))
  }

  const onUnselect = (id: string) => {
    const target = selectedMarkets.find((item) => item.id === id)
    if (!target) {
      return
    }

    setFieldValue(selectedMarkets?.filter((m) => m.id !== target?.id))
  }

  const onUnselectAll = () => {
    setFieldValue([])
  }

  return (
    <SearchInputSelectFieldGroup
      placeholder={placeholder}
      name='searchMarkets'
      testid='searchMarkets'
      onInputFinished={onInputFinished}
      selectableItems={validSearchResult}
      selectedItems={selectedMarkets}
      onSelect={onSelect}
      onUnselect={onUnselect}
      onUnselectAll={onUnselectAll}
    />
  )
})
